import { render } from "./ScanCodeButton.vue?vue&type=template&id=065f795c"
import script from "./ScanCodeButton.vue?vue&type=script&lang=js"
export * from "./ScanCodeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__